import { render, staticRenderFns } from "./ExactProductDetail.vue?vue&type=template&id=6ab77a4d&scoped=true&"
import script from "./ExactProductDetail.vue?vue&type=script&lang=js&"
export * from "./ExactProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExactProductDetail.vue?vue&type=style&index=0&id=6ab77a4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab77a4d",
  null
  
)

export default component.exports